"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Tue Jul 17 2018
 */

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * Internal pairs so called “Family” is a group of products which can have the same
 * brand name or same properties such as, same/similar package size or different flavors.
 * Not even similar products specification, but also family groups are sorted according
 *  to the customers purchase behaviors (expectation).
 * @author RV
 */


var FamilySettings =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(FamilySettings, _DomainObject_1$Domai);

  /**
   * Constructs Family settings instance.
   *
   * @param leaderMaxHistoryLength number of weeks, for which sales should be taken into account within recalculation of family leaders.
   * @param leaderFrequencyRecalculation frequency (number of weeks) based on which recalculation of family leaders should be performed.
   */
  function FamilySettings(leaderMaxHistoryLength, leaderFrequencyRecalculation) {
    var _this;

    _classCallCheck(this, FamilySettings);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FamilySettings).call(this));
    _this.leaderMaxHistoryLength = leaderMaxHistoryLength;
    _this.leaderFrequencyRecalculation = leaderFrequencyRecalculation;
    return _this;
  }

  return FamilySettings;
}(DomainObject_1.DomainObject);

exports.FamilySettings = FamilySettings; // tslint:disable-next-line:member-ordering

FamilySettings.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(FamilySettings.name);
  return {
    leaderMaxHistoryLength: builder.num('leaderMaxHistoryLength'),
    leaderFrequencyRecalculation: builder.num('leaderFrequencyRecalculation')
  };
}();